import React from "react";

const SvgBottom = props => (
  <svg
    style={{
      isolation: "isolate",
      width: '100%',
    }}
    viewBox="0 0 100 65.2"
    {...props}
    fill="currentColor" 
  >
    <defs>
      <clipPath id="Bottom_svg__a">
        <path
          fill="currentColor" 
          d="M0 0h100v65.2H0z" 
        />
      </clipPath>
    </defs>
    <g fill="currentColor" clipPath="url(#Bottom_svg__a)">
      <path fill="currentColor" d="M97.826 0H2.174C.974 0 0 .974 0 2.174v52.174c0 5.991 4.874 10.869 10.869 10.869H89.13c5.996 0 10.87-4.878 10.87-10.869V2.174C100 .974 99.026 0 97.826 0zm-2.174 54.348a6.53 6.53 0 0 1-6.522 6.521H10.87a6.53 6.53 0 0 1-6.522-6.521v-50h91.304v50z" />
      <path fill="currentColor" d="M20.539.226a2.192 2.192 0 0 0-2.922.974L8.922 18.591a2.179 2.179 0 0 0 1.948 3.148c.795 0 1.565-.439 1.947-1.204l8.696-17.391a2.178 2.178 0 0 0-.974-2.918zM42.274.226a2.185 2.185 0 0 0-2.917.974l-8.696 17.391a2.179 2.179 0 0 0 1.948 3.148c.795 0 1.565-.439 1.943-1.204l8.696-17.391a2.178 2.178 0 0 0-.974-2.918zM64.013.226a2.189 2.189 0 0 0-2.918.974L52.4 18.591a2.179 2.179 0 0 0 1.948 3.148c.795 0 1.565-.439 1.943-1.204l8.696-17.391a2.178 2.178 0 0 0-.974-2.918zM85.752.226a2.185 2.185 0 0 0-2.917.974l-8.696 17.391a2.179 2.179 0 0 0 1.948 3.148c.796 0 1.565-.439 1.943-1.204l8.696-17.391a2.178 2.178 0 0 0-.974-2.918z" />
      <path fill="currentColor" d="M97.826 17.391H2.174a2.175 2.175 0 0 0 0 4.348h95.652a2.175 2.175 0 0 0 0-4.348z" />
    </g>
  </svg>
);

export default SvgBottom;